export default {
  notifications: {
    showSuccessUpdate: {
      title: 'Updated',
      type: 'success'
    },

    showSuccessCreated: {
      title: 'Created',
      type: 'success'
    },

    showSuccessCopied: {
      title: 'Copied',
      type: 'success'
    },

    showSuccessDeleted: {
      title: 'Deleted',
      type: 'success'
    },

    showWarning: {
      title: 'Warning',
      message: "Warning",
      type: 'warn'
    },

    showError: {
      title: 'Error',
      message: 'Something goes wrong',
      type: 'error'
    }
  }
};
